import { createActionGroup, props } from '@ngrx/store';

export const UserActions = createActionGroup({
  source: 'User',
  events: { 'Get Many For Campaign': props<{ params: any }>() }
});
